import { addToRecentNavigation } from '../assets/javascript/utils';

export default defineNuxtRouteMiddleware((to, _from) => {
  addToRecentNavigation(to);
});
